import { db } from "./firebase";
import { collection, addDoc, updateDoc, deleteDoc, doc, query, where, getDocs, getDoc, serverTimestamp } from "firebase/firestore";

const TASKS_COLLECTION = "tasks";

class TaskService {
    constructor() {
        // Basic task service implementation
    }
    
    async getTasks() {
        try {
            const tasksQuery = query(collection(db, TASKS_COLLECTION));
            const snapshot = await getDocs(tasksQuery);
            return snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
        } catch (error) {
            return [];
        }
    }

    async getAgentTasks(agentId) {
        try {
            const tasksQuery = query(
                collection(db, TASKS_COLLECTION),
                where("assignedTo", "==", agentId)
            );
            const snapshot = await getDocs(tasksQuery);
            return snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
        } catch (error) {
            return [];
        }
    }

    async createTask(taskData) {
        try {
            const docRef = await addDoc(collection(db, "tasks"), {
                ...taskData,
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString(),
                status: "pending"
            });
            return { success: true, id: docRef.id };
        } catch (error) {
            return { success: false, error: error.message };
        }
    }

    async updateTask(taskId, updateData) {
        try {
            const taskRef = doc(db, "tasks", taskId);
            await updateDoc(taskRef, {
                ...updateData,
                updatedAt: new Date().toISOString()
            });
            return { success: true };
        } catch (error) {
            return { success: false, error: error.message };
        }
    }

    async deleteTask(taskId) {
        try {
            const taskRef = doc(db, "tasks", taskId);
            await deleteDoc(taskRef);
            return { success: true };
        } catch (error) {
            return { success: false, error: error.message };
        }
    }

    async getTask(taskId) {
        try {
            const taskRef = doc(db, "tasks", taskId);
            const taskDoc = await getDoc(taskRef);
            if (taskDoc.exists()) {
                return { success: true, data: { id: taskDoc.id, ...taskDoc.data() } };
            } else {
                return { success: false, error: "Task not found" };
            }
        } catch (error) {
            return { success: false, error: error.message };
        }
    }

    async getAllTasks() {
        try {
            const tasksQuery = query(collection(db, "tasks"));
            const querySnapshot = await getDocs(tasksQuery);
            const tasks = [];
            querySnapshot.forEach((doc) => {
                tasks.push({ id: doc.id, ...doc.data() });
            });
            return { success: true, data: tasks };
        } catch (error) {
            return { success: false, error: error.message };
        }
    }

    async getTasksByStatus(status) {
        try {
            const tasksQuery = query(
                collection(db, "tasks"),
                where("status", "==", status)
            );
            const querySnapshot = await getDocs(tasksQuery);
            const tasks = [];
            querySnapshot.forEach((doc) => {
                tasks.push({ id: doc.id, ...doc.data() });
            });
            return { success: true, data: tasks };
        } catch (error) {
            return { success: false, error: error.message };
        }
    }

    async delegateTask(taskId, agentId) {
        const taskRef = doc(db, TASKS_COLLECTION, taskId);
        const updateData = {
            assignedAgentId: agentId,
            status: "assigned",
            assignedAt: serverTimestamp(),
            updatedAt: serverTimestamp()
        };

        await updateDoc(taskRef, updateData);
    }
}

export const taskService = new TaskService(); 